import {AfterViewInit, Directive, ElementRef, OnDestroy} from '@angular/core';

@Directive({
  selector: '[disableSwipe]',
})
export class DisableSwipeDirective implements AfterViewInit, OnDestroy {
  private handlers = (event: any) => {
    const target = event.target as HTMLElement;

    // 1. Laisser passer les clics sur les boutons
    if (target.closest('button') || target.closest('a') || target.closest('.clickable')) {
      return;
    }

    // 2. Bloquer TOUTE propagation horizontale vers PrimeNG
    // On ne fait pas de calcul de delta complexe ici, on bloque juste
    // la remontée de l'événement vers les scripts de PrimeNG.
    event.stopPropagation();

    // 3. Pour le mouvement, on laisse le navigateur décider via le CSS (pan-y)
    // On ne fait PAS de preventDefault() ici, sinon on tue le scroll vertical.
  };

  constructor(private el: ElementRef) {
  }

  ngAfterViewInit() {
    const element = this.el.nativeElement;
    // On utilise addEventListener avec useCapture = true (le 3ème argument)
    // C'est crucial : cela permet d'intercepter l'événement AVANT PrimeNG
    const events = ['touchstart', 'touchmove', 'touchend', 'mousedown', 'mousemove', 'mouseup'];

    events.forEach(name => {
      element.addEventListener(name, this.handlers, true);
    });
  }

  ngOnDestroy() {
    const element = this.el.nativeElement;
    const events = ['touchstart', 'touchmove', 'touchend', 'mousedown', 'mousemove', 'mouseup'];
    events.forEach(name => {
      element.removeEventListener(name, this.handlers, true);
    });
  }
}
